/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberSearchShowAlbumResponse } from "./MemberSearchShowAlbumResponse";

export type MemberSearchShowAlbumResponseApiRespoonse = {
  data?: MemberSearchShowAlbumResponse;
  status?: MemberSearchShowAlbumResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberSearchShowAlbumResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
